import styled from 'styled-components'
import Label from './Label'

export default styled(Label)`
  padding-bottom: 10px;
  height: 20px;
  display: flex;
  align-items: center;
`
